import Navigation from "../Navigation";
import {Outlet} from "react-router-dom";
import {Box} from "@mui/material";
import Footer from "../Footer";

function Main() {
    return (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
            backgroundColor: 'background.default'
        }}>
            <Navigation/>

            <Box component="main" sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column"
            }}>
                <Outlet/>
            </Box>

            <Footer/>
        </Box>
    )
}

export default Main;